import React from 'react';

const StanInfo = ({ adresa, kvadratura, brojSoba, tip }) => {
  return (
    <div
      className="bg-gray-800 bg-opacity-70 text-white rounded-lg absolute inset-0 flex flex-col items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-500 transform hover:scale-105 border border-pink-500"
      style={{
        padding: 0,         // Uklanjamo padding
        margin: 0,          // Uklanjamo margine
        boxSizing: 'border-box',  // Osiguravamo da border ne utiče na dimenzije
      }}
    >
      <h3 className="text-lg font-bold mb-1">{adresa}</h3>
      <p className="mt-1 text-sm md:text-base">
        Kvadratura: <span className="font-semibold">{kvadratura} m²</span>
      </p>
      <p className="mt-1 text-sm md:text-base">
        Broj soba: <span className="font-semibold">{brojSoba}</span>
      </p>
      <p className="mt-3 font-semibold text-pink-500 text-base">
        {tip}
      </p>
    </div>
  );
};

export default StanInfo;
